module.exports = __webpack_public_path__ + "static/media/kaja.7248aa1c.jpg";